var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagasTelitettseg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H5C6.10457 0 7 0.895431 7 2V18H0V2Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8C9 6.89543 9.89543 6 11 6H14C15.1046 6 16 6.89543 16 8V18H9V8Z",
    fill: "#F4C000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18 12.8954 18.8954 12 20 12H23C24.1046 12 25 12.8954 25 14V18H18V14Z",
    fill: "#F4C000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagasTelitettseg);
export default __webpack_public_path__ + "static/media/magas-telitettseg.94a30bc62831820848826166343ebc59.svg";
export { ForwardRef as ReactComponent };